import { createContext } from 'preact'
import { useMemo, useState } from 'preact/hooks'

export const useGeneratorForm = () => {
  const [projectId, setProjectId] = useState<number | null>(null)
  const [presetId, setPresetId] = useState<number | null>(null)
  const [postId, setPostId] = useState<number>()
  const [variants, setVariants] = useState<string[]>([])
  const [context, setContext] = useState('')
  const [toneId, setToneId] = useState<number | null>(null)

  return useMemo(() => ({
    projectId,
    setProjectId,
    presetId,
    setPresetId,
    postId,
    setPostId,
    variants,
    setVariants,
    context,
    setContext,
    toneId,
    setToneId,
  }), [projectId, presetId, postId, variants, context, toneId])
}

export type GeneratorForm = ReturnType<typeof useGeneratorForm>

export const GeneratorFormContext = createContext<GeneratorForm | undefined>(undefined)
